import { Box, Button, Input } from "@mui/material";
import { useState } from "react";
import Swal from "sweetalert2"; // Import SweetAlert2 for alerts
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { allSuspendedTransactions } from "../../../../data/Axios/queries";
import { getSuspendedTransactionsColumns } from "../../../../data/DynamicTable/AccountsColumns";
import { generateAndExecuteReconcileSuspendedTxn } from "../../../../data/Axios/DynamicService";

const base_url = AccountsandFinanceurl.uri;

function SuspendedTransactionsTable() {
  const [file, setFile] = useState(null);
  const [refetchKey, setRefetchKey] = useState(0);

  // Function to handle Reconcile action button
  const handleReconcileAction = async (data) => {

    // Show confirmation dialog using SweetAlert2
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to reconcile this transaction?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reconcile it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      // Proceed with reconciliation if the user confirms
      // Get companyId from the decoded token
      const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
      const companyId = parseInt(decodedToken.CompanyId);

      const suspendedC2BData = {
        id: data.id,
        billRefNumber: data.billRefNumber || "",
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        companyId: companyId,
        transTime: data.transTime || "",
        transactionType: data.transactionType || "",
        transAmount: data.transAmount || 0,
        transID: data.transID || "",
      };

      try {
        const response = await generateAndExecuteReconcileSuspendedTxn(
          suspendedC2BData,
          base_url
        );

        // Show success message using SweetAlert2
        Swal.fire({
          icon: "success",
          title: "Transaction Reconciled",
          text: "The suspended transaction has been successfully reconciled.",
          confirmButtonText: "OK",
        }).then(() => {
          // Refetch data by updating refetchKey
          setRefetchKey((prevKey) => prevKey + 1);
        });
      } catch (error) {
        console.error("Error executing mutation:", error);
        // Show error message using SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Reconciliation Failed",
          text: "There was an error reconciling the transaction. Please try again.",
          confirmButtonText: "OK",
        });
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // If user cancels, show a cancellation message (optional)
      Swal.fire({
        icon: "info",
        title: "Reconciliation Cancelled",
        text: "The transaction was not reconciled.",
        confirmButtonText: "OK",
      });
    }
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "image/svg+xml") {
      setFile(selectedFile);
    } else {
      alert("Please upload a valid SVG file.");
    }
  };

  // Handle file upload
  const handleFileUpload = () => {
    if (file) {
      // Implement your file upload logic here
    } else {
      alert("No file selected.");
    }
  };

  const actions = {
    entity: "SuspendedTransactions",
    isSubRight: true,
    showStatus: true,
  };

  return (
    <Box m="2px">
      {/* File Upload Section */}
      <Box display="flex" justifyContent="space-between" mb="20px">
        <Input
          type="file"
          inputProps={{ accept: ".svg" }}
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleFileUpload}
          disabled={!file}
          style={{ marginLeft: "8px" }}
        >
          Upload Statement
        </Button>
      </Box>

      {/* DynamicTable for Suspended Transactions */}
      <DynamicTable
        key={refetchKey} // Unique key to force re-mount and refetch
        title="Suspended Transactions"
        subtitle="View Suspended Transactions"
        columns={getSuspendedTransactionsColumns(handleReconcileAction)}
        query={allSuspendedTransactions}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default SuspendedTransactionsTable;
